import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineCalendarAltIcon from 'LuxKit/Icons/line/LineCalendarAltIcon'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyLuxPlusRenewalBonusEnabled from 'loyalty/selectors/getIsLoyaltyLuxPlusRenewalBonusEnabled'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import { getIsPendingRenewalLuxPlusMember } from 'luxPlus/selectors/featureToggle'
import { FormattedMessage } from 'react-intl'
import { getLuxPlusSubscriptionRenewalOrExpiryDate } from 'selectors/luxPlusSelectors'

interface Props {
  item: App.MemberSubscriptionItem
}

function LuxPlusManageAccountModalMembershipStatusBanner({ item }: Props) {
  const isLoyaltyLuxPlusRenewalBonusEnabled = useAppSelector(getIsLoyaltyLuxPlusRenewalBonusEnabled)
  const isPendingRenewal = useAppSelector(getIsPendingRenewalLuxPlusMember)
  const subscriptionRenewalOrExpiryDate = useAppSelector(getLuxPlusSubscriptionRenewalOrExpiryDate)
  const canRenew = item.renewalStatus === 'ALLOW_RENEWAL'

  if (isPendingRenewal || !subscriptionRenewalOrExpiryDate) return null

  const renewalDate = <FormatDateTime value={subscriptionRenewalOrExpiryDate} dateStyle="medium" />

  const renewsMessage = <FormattedMessage
    id="Kzgej2gsA6CaKfQSV6_r"
    defaultMessage="Your {programName} Membership renews on {date}"
    description="Banner message showing LuxPlus+ membership renewal date"
    values={{ programName: LUXURY_PLUS.PROGRAM_NAME, date: renewalDate }}
  />

  const endsMessage = <FormattedMessage
    id="iDJ7uAOq1qcKFiXcSnK3"
    defaultMessage="Your {programName} Membership ends on {date}"
    description="Banner message showing LuxPlus+ membership expiry date"
    values={{ programName: LUXURY_PLUS.PROGRAM_NAME, date: renewalDate }}
  />

  return <MessageBanner
    kind="informational"
    density="compact"
    icon={<LineCalendarAltIcon />}
  >
    <b>{canRenew ? renewsMessage : endsMessage}</b>
    {isLoyaltyLuxPlusRenewalBonusEnabled && <><br /><FormattedMessage
      id="FzsGGf8Tct1v7lZXfyLt"
      defaultMessage="{loyaltyProgramName} points & status credits will be credited after this date"
      description="Note about loyalty points and status credits being credited after LuxPlus+ membership renewal date"
      values={{ loyaltyProgramName: getLoyaltyProgramDisplayName() }}
    />
    </>}
  </MessageBanner>
}

export default LuxPlusManageAccountModalMembershipStatusBanner
